// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__wecRA","imageUploader":"EGiftCard_imageUploader__2yJGT"};